import React from 'react'
import { SettingsPage } from '@sales-center/components'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export function ServiceCodeSettings() {
  return (
    <SettingsPage padding="0">
      <Box sx={{ px: 5, pt: 5 }}>
        <Typography variant="h4" mb={3.2} noWrap>
          Service Code Settings
        </Typography>
      </Box>
    </SettingsPage>
  )
}

ServiceCodeSettings.displayName = 'ServiceCodeSettings'
